/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Webvtt_VttInputs */

const en_webvtt_vtt = /** @type {(inputs: Webvtt_VttInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebVtt (.vtt)`)
};

const fr_webvtt_vtt = /** @type {(inputs: Webvtt_VttInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebVtt (.vtt)`)
};

const de_webvtt_vtt = /** @type {(inputs: Webvtt_VttInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebVtt (.vtt)`)
};

const it_webvtt_vtt = /** @type {(inputs: Webvtt_VttInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebVtt (.vtt)`)
};

const ru_webvtt_vtt = /** @type {(inputs: Webvtt_VttInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebVtt (.vtt)`)
};

const es_webvtt_vtt = /** @type {(inputs: Webvtt_VttInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebVtt (.vtt)`)
};

const zh_cn2_webvtt_vtt = /** @type {(inputs: Webvtt_VttInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebVtt (.vtt)`)
};

const ja_webvtt_vtt = /** @type {(inputs: Webvtt_VttInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebVtt (.vtt)`)
};

const hi_webvtt_vtt = /** @type {(inputs: Webvtt_VttInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वेबवीटीटी (.vtt)`)
};

const pt_pt2_webvtt_vtt = /** @type {(inputs: Webvtt_VttInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WebVtt (.vtt)`)
};

/**
* | output |
* | --- |
* | "WebVtt (.vtt)" |
*
* @param {Webvtt_VttInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const webvtt_vtt = /** @type {((inputs?: Webvtt_VttInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Webvtt_VttInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_webvtt_vtt(inputs)
	if (locale === "de") return de_webvtt_vtt(inputs)
	if (locale === "it") return it_webvtt_vtt(inputs)
	if (locale === "ru") return ru_webvtt_vtt(inputs)
	if (locale === "es") return es_webvtt_vtt(inputs)
	if (locale === "zh-CN") return zh_cn2_webvtt_vtt(inputs)
	if (locale === "ja") return ja_webvtt_vtt(inputs)
	if (locale === "hi") return hi_webvtt_vtt(inputs)
	if (locale === "pt-PT") return pt_pt2_webvtt_vtt(inputs)
	return en_webvtt_vtt(inputs)
});